import config from "../config";

export const PLAN_LINK = "https://resources.pga.org/member-benefits/deferred-compensation";
export const PLAN_DETAILS_LINK = "https://resources.pga.org/member-benefits/deferred-compensation/plan-details";
export const JOB_PREFERENCES_LINK = "https://account.pga.org/job-preferences";
export const CAREER_SERVICES_LINK = "https://resources.pga.org/career-advancement/career-services/pga-career-consultants";
export const PDR_LINK = "https://resources.pga.org/my-membership/earn-and-report-pdrs/";

export const pgaLink = (link: string) => (config.isProd ? link : link.replace(".pga.org", ".sandboxpga.org"));
